var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapse-box',{attrs:{"collapseData":_vm.dataByProjectCategory,"spinning":_vm.spinning},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var module = ref.record;
return [(module.quotationId)?_c('module-item',{key:module.id,attrs:{"module":module,"active":_vm.activeId === module.id}}):_c('module-template-item',{key:module.id,attrs:{"module":module,"active":_vm.activeId === module.id}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }